import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  const features = [
    {
      id: 1,
      icon: 'LayoutDashboard',
      title: 'Project Management',
      description: 'Coordinate multiple renovation projects with ease'
    },
    {
      id: 2,
      icon: 'Users',
      title: 'Team Collaboration',
      description: 'Seamlessly work with subcontractors across all trades'
    },
    {
      id: 3,
      icon: 'Bell',
      title: 'Smart Notifications',
      description: 'Stay updated with automated alerts and reminders'
    },
    {
      id: 4,
      icon: 'Calendar',
      title: 'Timeline Tracking',
      description: 'Monitor actual vs suggested dates for every phase'
    }
  ];

  return (
    <div className="w-full space-y-4">
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-foreground mb-2">
          Streamline Your Renovation Projects
        </h3>
        <p className="text-sm text-muted-foreground">
          Everything you need to manage construction projects efficiently
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {features?.map((feature) => (
          <div
            key={feature?.id}
            className="flex items-start gap-3 p-4 bg-card rounded-lg border border-border hover:border-primary/50 transition-smooth"
          >
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
              <Icon name={feature?.icon} size={20} color="var(--color-primary)" strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground mb-1">{feature?.title}</h4>
              <p className="text-xs text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureHighlights;